"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _popover_props = require("./popover_props");

require("../../css/shared/popover.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PopoverCssPositioned = function PopoverCssPositioned(_ref) {
  var _classNames2, _classNames3;

  var alignment = _ref.alignment,
      arrow = _ref.arrow,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      contentClassName = _ref.contentClassName,
      contentVisible = _ref.contentVisible,
      interactionHandlers = _ref.interactionHandlers,
      position = _ref.position,
      targetClassName = _ref.targetClassName,
      targetRole = _ref.targetRole,
      targetTabIndex = _ref.targetTabIndex;
  var classes = (0, _classnames.default)(_defineProperty({
    'vn-popover': true
  }, className, className != null));
  var targetClasses = (0, _classnames.default)((_classNames2 = {
    'vn-popover__target': true,
    'vn-popover__target--arrow': arrow,
    'vn-popover__target--visible': contentVisible
  }, _defineProperty(_classNames2, "vn-popover__target--".concat(position), true), _defineProperty(_classNames2, targetClassName, targetClassName != null), _classNames2));
  var contentClasses = (0, _classnames.default)((_classNames3 = {
    'vn-popover__content': true,
    'vn-popover__content--visible': contentVisible
  }, _defineProperty(_classNames3, "vn-popover__content--".concat(position), true), _defineProperty(_classNames3, "vn-popover__content--".concat(alignment, "-aligned"), !arrow), _defineProperty(_classNames3, "vn-popover__content--with-arrow-".concat(alignment, "-aligned"), arrow), _defineProperty(_classNames3, contentClassName, contentClassName != null), _classNames3));
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("a", _extends({
    className: targetClasses
  }, interactionHandlers, {
    role: targetRole,
    tabIndex: targetTabIndex
  }), children), _react.default.createElement("div", {
    className: contentClasses
  }, content));
};

PopoverCssPositioned.propTypes = _popover_props.propTypes;
PopoverCssPositioned.defaultProps = _popover_props.defaultProps;
PopoverCssPositioned.displayName = 'PopoverCssPositioned';
var _default = PopoverCssPositioned;
exports.default = _default;